import React, { useEffect, useState } from "react";
import { get } from "../../../lib/api";

const TimelineBar = ({ gameId }) => {
  const [challenges, setChallenges] = useState([]);

  useEffect(() => {
    if (!gameId) return;
    const fetchChallenges = async () => {
      const today = new Date();
      // Calculate yesterday's date string
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      const yesterdayString = yesterday.toISOString().split("T")[0];

      // Fetch from yesterday to 2100-01-01
      const url = `/statistics?method=getDailyChallenge&gameid=${gameId}&date=${yesterdayString}_2100-01-01`;
      try {
        const response = await get(url);
        // response: { date: [...], daily_challenge_info: [...] }
        const data = response.date.map((date, idx) => ({
          date,
          info: response.daily_challenge_info[idx],
        }));
        setChallenges(data);
      } catch (e) {
        setChallenges([]);
      }
    };
    fetchChallenges();
  }, [gameId]);

  // Find yesterday, today, tomorrow, day after tomorrow
  const getTimeline = () => {
    const today = new Date();
    const days = [
      { label: "Yesterday", offset: -1 },
      { label: "Today", offset: 0 },
      { label: "Tomorrow", offset: 1 },
      { label: "Day After Tomorrow", offset: 2 },
    ];
    return days.map(({ label, offset }) => {
      const d = new Date(today);
      d.setDate(today.getDate() + offset);
      const dStr = d.toISOString().split("T")[0];
      const challenge = challenges.find((c) => c.date === dStr);
      return {
        label,
        challenge,
        date: dStr,
      };
    });
  };

  const timeline = getTimeline();

  return (
    <div
      className="mt-4 dark:!bg-[var(--header-color-dark)] bg-[#ffffff] text-black dark:!text-white rounded-lg shadow-md p-4 overflow-x-auto"
      style={{ width: '100%', maxWidth: typeof window !== 'undefined' && window.innerWidth < 768 ? '90vw' : '100vw', boxSizing: 'border-box' }}
    >
      <div
        className="flex justify-between items-center w-full"
        style={{ flexDirection: 'row' }}
      >
        <div
          className="flex w-full"
          style={{
            flexDirection: typeof window !== 'undefined' && window.innerWidth < 768 ? 'column' : 'row',
            gap: typeof window !== 'undefined' && window.innerWidth < 768 ? '1rem' : undefined,
          }}
        >
          {timeline.map(({ label, challenge, date }) => (
            <div
              key={label}
              className={`flex-1 flex flex-col items-center p-2 md:p-4 rounded-lg ${label === "Today" ? "bg-gray-50 dark:bg-[#2c313c] shadow-md" : ""}`}
              style={typeof window !== 'undefined' && window.innerWidth < 768 ? { width: '100%', alignItems: 'stretch' } : {}}
            >
              <div className="text-xs md:text-sm font-medium text-gray-400 mb-2 text-center">{label}</div>
              <div className="flex items-center space-x-2 justify-center">
                <div
                  className={`w-2 h-2 rounded-full ${
                    label === "Yesterday"
                      ? "bg-green-400"
                      : label === "Today"
                      ? "bg-green-500"
                      : "bg-sky-400"
                  }`}
                />
                <span className="text-xs md:text-base font-semibold truncate max-w-[120px] md:max-w-full">
                  {challenge?.info || "No Challenge"}
                </span>
              </div>
              <div className="text-[10px] md:text-xs text-gray-400 mt-1 text-center">{challenge?.date && new Date(challenge.date).toLocaleDateString()}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TimelineBar; 